import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { store } from 'redux-rest-reducer';
import styled from 'styled-components';

import { renderFormField } from 'modules/form';
import { studentRevertUpgradePaymentLinkFields } from 'constants/form';
import { Button, Row, Separator } from '@cuemath/comps';
import BallLoader from 'comps/ball-loader';
import { Message } from 'modules/form';
import { checkButtonStatus } from 'utils';

import { patch as patchStudentRevertUpgradePaymentLink } from 'actions/student-revert-upgrade-payment-link';
import { closeModal } from 'actions/modal';

const Wrapper = styled.div`
  padding: 40px 10px 20px;
`;

const ButtonWrapper = styled(Row)`
  justify-content: center;
`;

const Heading = styled.h4`
  text-align: center;
  margin-bottom: 30px;
`;

function getFormDefaults() {
  const formDefaults = {};

  studentRevertUpgradePaymentLinkFields.forEach(field => {
    formDefaults[field.name] = field.default;
  });
  return formDefaults;
}

let timeout = null;

const StudentRevertUpgradePaymentLinkForm = ({
  studentCourse,
  actions,
  studentRevertUpgradePaymentLink,
}) => {
  const [form, setForm] = useState(getFormDefaults());
  const [fields, setFields] = useState(studentRevertUpgradePaymentLinkFields);
  const [success, setSuccess] = useState(false);
  const [patchData] = useState(store.patch());
  const { id: patchId } = patchData || {};

  const patchStudentRevertUpgradePaymentLink = store.patch(
    studentRevertUpgradePaymentLink,
    patchId,
  );
  const { resolved: patchResolved, current: patchCurrent } =
    patchStudentRevertUpgradePaymentLink || {};
  const { isPatching } = patchCurrent || {};
  const { data, isPatched, isPatchingFailed, __ERROR__: error } = patchResolved || {};
  const { band_details: onlineBandList, status } = data || {};
  const errorMessage = typeof error === 'string' ? error : error?.message;

  const { id: studentCourseId } = studentCourse || {};

  const onCloseModal = () => {
    timeout = setTimeout(() => {
      actions.closeModal();
    }, 1500);
  };
  useEffect(() => {
    if (studentCourseId) {
      const patchData = {
        action: 'FETCH_BAND_DETAILS',
      };
      actions.patchStudentRevertUpgradePaymentLink(patchId, studentCourseId, patchData);
    }
    return () => {
      clearTimeout(timeout);
      timeout = null;
    };
  }, []);

  useEffect(() => {
    if (isPatched) {
      if (status) {
        setSuccess('Revert Upgrade done Successfully');
        onCloseModal();
      } else {
        fillFields();
      }
    }
  }, [isPatched]);

  function fillFields() {
    const newFields =
      fields &&
      fields.map(field => {
        let modifiedChoices = [];
        onlineBandList.forEach(band => {
          const { id: onlineBandId, name } = band || {};
          modifiedChoices.push({ label: name, value: onlineBandId });
        });
        return { ...field, choices: modifiedChoices, disabled: false };
      });

    setFields(newFields);
  }

  const onOptionChange = (key, value) => {
    let newForm = { ...form };
    newForm[key] = value;
    setForm(newForm);
  };

  const onConfirm = () => {
    const { online_band_list: onlineBandId } = form || {};
    const patchData = {
      action: 'REVERT_PAYMENT_LINK',
      band_id: onlineBandId,
    };
    actions.patchStudentRevertUpgradePaymentLink(patchId, studentCourseId, patchData);
  };

  const isButtonDisabled = checkButtonStatus(form);
  const buttonLabel = 'Submit';

  return (
    <Wrapper>
      <Heading>Please select the correct band</Heading>
      {fields &&
        fields.map(field =>
          renderFormField({
            ...field,
            value: form[field.name],
            onChange: onOptionChange,
          }),
        )}
      {success ? (
        <Message width="100%">{success}</Message>
      ) : (
        <>
          <Separator transparent height="20" />
          <ButtonWrapper>
            {isPatching ? (
              <BallLoader />
            ) : (
              <Button
                align="center"
                label={buttonLabel}
                onClick={onConfirm}
                disabled={isButtonDisabled}
              />
            )}
          </ButtonWrapper>
        </>
      )}
      {isPatchingFailed && (
        <Message width="100%" error>
          {errorMessage ? errorMessage : 'Something went wrong'}
        </Message>
      )}
    </Wrapper>
  );
};

export default connect(
  ({ studentRevertUpgradePaymentLink }) => {
    return { studentRevertUpgradePaymentLink };
  },
  dispatch => ({
    actions: bindActionCreators(
      {
        patchStudentRevertUpgradePaymentLink,
        closeModal,
      },
      dispatch,
    ),
  }),
)(StudentRevertUpgradePaymentLinkForm);
